import createValidationElementUtil
from 'modules/redux/utils/create-validation-element'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  empty: {
    id: 'empty',
    defaultMessage: 'The {name} can’t be empty.',
    description: 'Used to validate an empty value.'
  },
  short: {
    id: 'short',
    defaultMessage: 'The {name} is too short, use at least {min} characters.',
    description: 'Used to validate a value that is too short.'
  },
  long: {
    id: 'long',
    defaultMessage: 'The {name} is too long, use {max} characters maximum.',
    description: 'Used to validate a value that is too long.'
  }
})

function isInLengthValidatorUtil (params) {
  const {
    key,
    name,
    max,
    min,
    value
  } = params
  if (!value) {
    return createValidationElementUtil(
      key, messages.empty, { name }
    )
  }
  if (value.length < min) {
    return createValidationElementUtil(
      key, messages.short, {
        name,
        min
      }
    )
  }
  if (value.length > max) {
    return createValidationElementUtil(
      key, messages.long, {
        name,
        max
      }
    )
  }
  return true
}

export default isInLengthValidatorUtil
